'use strict';

export const Constants = Object.freeze({
  AUSTRALIA_SHORT_CODE: 'AU',
});
